// checks if the url starts with a slash
const isAbsolutePath = (path: string) =>
  path &&
  (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('//') || path.startsWith('www'));

export default isAbsolutePath;
